import { AxiosRequestConfig } from './types';
import { processHeaders } from './helpers/headers';
import { transformRequest, transformResponse } from './helpers/data';

const defaults: AxiosRequestConfig = {
  method: 'get',
  timeout: 0,
  headers: {
    common: {
      Accept: 'application/json, text/plain, */*'
    }
  },
  xsrfCookieName: 'XSRF-TOKEN', // token存本地cookie时的默认名字
  xsrfHeaderName: 'X-XSRF-TOKEN', // 请求时header中携带token时的名字
  transformRequest: [
    // 默认请求处理逻辑
    function (data: any, headers: any): any {
      processHeaders(headers, data); // 转换headers, 必须在处理data 之前调用，因为处理data后data会是一个string，会影响header的处理
      return transformRequest(data); // 转换请求data
    }
  ],
  transformResponse: [
    // 默认响应函数处理逻辑
    function (data: any): any {
      return transformResponse(data);
    }
  ],
  // 设置合法响应状态值区间
  validateStatus(status: number): boolean {
    return status >=200 && status < 300;
  }
}

// 没有参数的请求，默认添加个空的header
const methodsNoData = ['delete', 'get', 'head', 'options'];

methodsNoData.forEach(method => {
  defaults.headers[method] = {}
})

// 有参数的请求，默认添加个带content-type 的header
const methodsWithData = ['post', 'put', 'patch'];

methodsWithData.forEach(method => {
  defaults.headers[method] = {
    'Content-Type': 'application/x-www-form-urlencoded'
  }
});

export default defaults;